export default {
  buttons: {
    go_to_basket: 'Vai al carrello',
  },
};
